import { render, staticRenderFns } from "./formation.vue?vue&type=template&id=df3126bc&scoped=true"
import script from "./formation.vue?vue&type=script&lang=js"
export * from "./formation.vue?vue&type=script&lang=js"
import style1 from "./formation.vue?vue&type=style&index=1&id=df3126bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3126bc",
  null
  
)

export default component.exports